"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
var _CopyrightLabel = _interopRequireDefault(require("../../../../molecules/CopyrightLabel"));
var CenterStackedVTwoFooter = function CenterStackedVTwoFooter(props) {
  var copyright = props.copyright,
    logo = props.logo,
    bottomColor = props.bottomColor;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'center',
      backgroundColor: bottomColor,
      paddingTop: '1.2em',
      paddingBottom: '1.2em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_CopyrightLabel["default"], {
    company: copyright.company,
    phrase: copyright.phrase
  }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
    src: logo,
    centered: true,
    size: "small",
    style: {
      paddingTop: '.9em'
    }
  }));
};
CenterStackedVTwoFooter.propTypes = {
  bottomColor: _propTypes["default"].string.isRequired,
  logo: _propTypes["default"].string.isRequired
};
var _default = CenterStackedVTwoFooter;
exports["default"] = _default;